import { render, staticRenderFns } from "./prescriptionPreview.vue?vue&type=template&id=c7508fba&scoped=true"
import script from "./prescriptionPreview.vue?vue&type=script&lang=js"
export * from "./prescriptionPreview.vue?vue&type=script&lang=js"
import style0 from "./prescriptionPreview.vue?vue&type=style&index=0&id=c7508fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7508fba",
  null
  
)

export default component.exports